import { createStoreCreator } from 'lib/store'
import reducer from 'oee/locationChangeovers/reducers'

export default createStoreCreator(reducer)
